<mat-toolbar>
  <div fxLayout="row" fxLayoutAlign="center center" fxFlex>
    <span class="mat-body-1">{{
      'PICA Product Development, LLC ©' + currYear + ' (' + version + ')'
    }}</span>
  </div>
</mat-toolbar>
